import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
export function Notice() {
  const {
    t
  } = useLanguage();
  return <motion.aside initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.45,
    ease: 'easeOut'
  }} className="my-12 border-l-4 border-accent bg-white/70 p-6" role="note" aria-labelledby="aviso-title" data-id="element-61" data-mp="33extl63ibis4">
      <h2 id="aviso-title" className="flex items-center gap-2 font-sans text-[12px] font-bold uppercase tracking-[0.2em] text-accent" data-id="element-62" data-mp="3r5tgbot3vnsi">
        <InfoIcon className="h-4 w-4" aria-hidden="true" data-id="element-63" data-mp="3h7ne163e0fn4" />
        {t.notice.title}
      </h2>
      <p className="mt-3 max-w-3xl text-[17px] leading-relaxed text-ink/90" data-id="element-64" data-mp="2aqs98kgd7vst">{t.notice.text}</p>
    </motion.aside>;
}